import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { Defaults } from '@styles/theme'

const colors = {
  onHover: '#D7DCEA',
  onClick: '#E8FDE2',
  onClickText: '#014C33'
}

const LabelComponent = ({
  children,
  onClick,
  suffix,
  className,
  link,
  outlined, // eslint-disable-line
  fowardRef,
  active,
  ...rest
}) => {
  return link ? (
    <Link active={active} to={link} className={className} {...rest}>
      {children} <div>{suffix}</div>
    </Link>
  ) : (
    <div className={className} onClick={onClick} ref={fowardRef} {...rest}>
      {children} <div>{suffix}</div>
    </div>
  )
}

LabelComponent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string,
  onClick: PropTypes.func,
  suffix: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  link: PropTypes.string,
  outlined: PropTypes.bool,
  fowardRef: PropTypes.any,
  active: PropTypes.bool,
}

const Label = styled(LabelComponent)`
  padding: 0.5rem 1rem;
  margin: 0.375rem 0.75rem;
  display: flex;
  justify-content: space-between;
  background: ${(props) =>
    props.active
      ? colors.onClick
      : props.solid
      ? props.theme.colors.surface
      : ''};
  box-sizing: border-box;
  line-height: 1;
  color: ${({ solid, theme }) =>
    solid ? theme.palette.text['200'] : theme.palette.text['300']};
  font-size: ${props => props.size ? `${props.size}rem` : "1rem"};
  font-weight: 500;
  border-radius: ${Defaults.borderRadius};

  text-decoration: none;

  width: ${(props) => (props.fill ? '100%' : '')};

  border: ${(props) => (props.outlined ? '1px solid #D7DCEA' : undefined)};

  user-select: none;

  transition: background 150ms ease-out;
  cursor: pointer;
  :hover {
    background: ${colors.onHover};
  }

  :active {
    background: ${colors.onClick};
    color: ${colors.onClickText};
  }
`

export default Label
